// lib/useLogger.ts
import {useEffect, useState} from "react";
import {getCurrentFileName, getRootLogger} from "./log";
import {ILogObj, Logger} from "tslog";

export function useLogger(metaUrl: string): Logger<ILogObj> {
    // create a synchronous default logger so we never return null
    const defaultLogger = new Logger<ILogObj>({
        type: "pretty",
        name: getCurrentFileName(metaUrl),
        minLevel: 6,
    });
    const [logger, setLogger] = useState<Logger<ILogObj>>(defaultLogger);

    useEffect(() => {
        getRootLogger().then(root => {
            const subLogger: Logger<ILogObj> = root.getSubLogger({
                name: getCurrentFileName(metaUrl)
            });
            setLogger(subLogger);

        });
        return () => {
        };
    }, [metaUrl]);

    return logger;
}